import supabase from "../supabaseClient/supabaseClient";

// Tells the backend a generated worksheet was downloaded, for the usage funnel.
// Best effort: a failure here must never get in the teacher's way.
export async function markGenerationExported(generationId) {
  if (!generationId) return;
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) return;
    await fetch(`${process.env.REACT_APP_BE_URL}/generations/${generationId}/exported`, {
      method: "POST",
      headers: { Authorization: `Bearer ${session.access_token}` },
    });
  } catch (error) {
    console.error("Failed to record export:", error);
  }
}
